__turbopack_context__.v({
  "best": "MBgqfG_best",
  "blink": "MBgqfG_blink",
  "cabinet": "MBgqfG_cabinet",
  "canvas": "MBgqfG_canvas",
  "coinBtn": "MBgqfG_coinBtn",
  "estimateCta": "MBgqfG_estimateCta",
  "holdHint": "MBgqfG_holdHint",
  "marquee": "MBgqfG_marquee",
  "overlay": "MBgqfG_overlay",
  "overlayClickable": "MBgqfG_overlayClickable",
  "overlaySub": "MBgqfG_overlaySub",
  "overlayTitle": "MBgqfG_overlayTitle",
  "playAgain": "MBgqfG_playAgain",
  "screen": "MBgqfG_screen",
  "showDesktop": "MBgqfG_showDesktop",
  "showMobile": "MBgqfG_showMobile",
  "sound": "MBgqfG_sound",
  "soundLabel": "MBgqfG_soundLabel",
  "summaryBody": "MBgqfG_summaryBody",
  "thrustBtn": "MBgqfG_thrustBtn",
  "thrustCap": "MBgqfG_thrustCap",
  "toggle": "MBgqfG_toggle",
  "toggleKnob": "MBgqfG_toggleKnob",
  "toggleOn": "MBgqfG_toggleOn",
});
